"use client";
import React from "react";
import PopularSubjectSlider from "@packages/shared-components/common-utilities/slider/popular-subject-slider/popular-subject-slider";
import { getCustomDomain } from "@packages/lib/utlils/common-function-server";
import {
  DataLayerGA4AttrType,
  GA4EventAttrType,
} from "@packages/lib/types/datalayerGA";
import {
  GA4DataLayer,
  GA4DataLayerFn,
} from "@packages/lib/utlils/helper-function";
import { generateProviderResultUrl } from "@packages/lib/utlils/url-builder";
import { GAConstants } from "@packages/shared-components/services/constants";

const PopularSubject = ({
  uniTitle,
  subjectTitle,
  popularSubjects,
  institutionId,
  institutionTextkey,
  commonGAAttrs,
  isPostgraduate,
  commonOldGAAttrs,
  hasUgCourses,
}: any) => {
  const handleGALogs = (
    eventName: string,
    ctaName: string,
    ctaUrl: string,
  ): GA4EventAttrType => {
    return {
      event: GAConstants.track_event,
      event_name: eventName,
      ...commonGAAttrs,
      click_text: ctaName || "NA",
      field: getCustomDomain() + ctaUrl || "NA",
    };
  };
  const handleOldGALogs = (
    eventName: string,
    ctaName: string,
    ctaUrl: string,
  ): DataLayerGA4AttrType => {
    return {
      event: "ga_events",
      eventName: eventName,
      ...commonOldGAAttrs,
      cta_name: ctaName || "NA",
      cta_url: getCustomDomain() + ctaUrl || "NA",
      data_label: "Popular Subjects",
    };
  };

  const prPageUrl = generateProviderResultUrl({
    institutionTextkey,
    isPostgraduate,
    hasUgCourses,
  });
  return (
    <div className="flex flex-col gap-[16px]">
      <div className="flex flex-col gap-[16px] px-[16px] md:px-[20px] lg:px-0">
        {uniTitle && (
          <div className="h5 md:text-heading5 font-bold font-farro">
            {uniTitle}
          </div>
        )}
        <div className="text-para-lg font-semibold">{subjectTitle}</div>
      </div>
      <PopularSubjectSlider
        popularSubjects={popularSubjects}
        institutionTextkey={institutionTextkey}
        institutionId={institutionId}
        commonGAAttrs={commonGAAttrs}
        isPostgraduate={isPostgraduate}
        commonOldGAAttrs={commonOldGAAttrs}
      />
      <div className="flex justify-center mt-[4px]">
        <a
          href={prPageUrl}
          className="flex items-center w-fit font-semibold small text-primary-400 hover:underline gap-[8px]"
          onClick={() => {
            GA4DataLayer(
              handleGALogs(
                "redirection_link_click",
                "View all courses",
                prPageUrl,
              ),
            );
            GA4DataLayerFn(
              handleOldGALogs(
                "providerlisting_links",
                "View all courses",
                `/degree-courses/csearch?university=${institutionTextkey}`,
              ),
            );
          }}
        >
          View all courses
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.4814 0.814819L14.6666 6M14.6666 6L9.4814 11.1852M14.6666 6L1.33325 6"
              stroke="#3460DC"
              strokeWidth="1.48148"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default PopularSubject;
